import { render, staticRenderFns } from "./StudentOverview.vue?vue&type=template&id=4bd9257d&"
import script from "./StudentOverview.vue?vue&type=script&lang=js&"
export * from "./StudentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports